import axios from "axios";
import {computed} from "vue";
import {useStore} from "vuex";

export function useUserData() {

    const {baseURL, nonce} = localized;
    const store = useStore();
    const currentUser = computed(() => store.state.user);
    const allUsers = computed(() => store.state.users);

    const getCurrentUser = () => {
        axios.get(this.baseURL + 'current_user', {
            headers: {
                'X-WP-Nonce': nonce
            }
        }).then(response => {
            store.commit('setUser', response.data);
        })
            .catch(error => {
                console.error(error);
            });
    }

    const getAllUsers = () => {
        axios.get(baseURL + 'users')
            .then(response => {
                store.commit('setUsers', response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    return {
        currentUser,
        allUsers,
        getCurrentUser,
        getAllUsers
    }
}